import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import moment from 'moment';

import { lockerService,accountService } from '../../_services';


function Search({ history, match }) {
    const { path } = match;

    let { searchstring } = useParams();

    const [formValuea, setFormValuea] = useState("");
    const [formValueb, setFormValueb] = useState(',');
    const [kiosks, setKiosks] = useState([]);

    useEffect(() => {
        lockerService.getVenues().then(x => setKiosks(x));
    },[]);

    const onChangeHandlera = (e) => {
        e.preventDefault();
        setFormValuea(e.target.value);
    }

    const onChangeHandlerb = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        if (name === 'start_date') {
            setFormValueb(`${value},${formValueb.split(',')[1]}`);
        } else if (name === 'end_date') {
            setFormValueb(`${formValueb.split(',')[0]},${value}`);
        }
    }

    const onSubmitHandlerb = (e) => {
        e.preventDefault();
        history.push('/admin/reservations/list/' + formValuea+ "," + formValueb + ",,");
    }

    const today = moment().format("YYYY-MM-DD");
    const tomorrow = moment().add(1, 'days').format("YYYY-MM-DD");
    const day_after_tomorrow = moment().add(2, 'days').format("YYYY-MM-DD");

    return (
        <div>
            <div className="card admin-top-rad bdr-0">
                <h1 className="card-header header-admin admin-btm-bdr">Reservations Admin</h1>
                <p><b>Search</b> matches against <b>email, last or first name, date</b></p>

                <div className="card-header admin-subheader-2 admin-subheader">
                    <div>
                        <input className="col-9 search" onChange={onChangeHandlera} id="searchbox" name="text" type="text" placeholder="Email, Last Name or First Name" />
                        <input className="col-4 search" onChange={onChangeHandlerb} id="searchbox2" name="start_date" type="text" placeholder="Select Start Date" onFocus={(e) => (e.target.type = "date")} onBlur={(e) => (e.target.type = "text")} />
                        <input className="col-4 search" onChange={onChangeHandlerb} id="searchbox3" name="end_date" type="text" placeholder="Select End Date" onFocus={(e) => (e.target.type = "date")} onBlur={(e) => (e.target.type = "text")} /> 
                    </div>
                    <div>
                        <button className="btn admin-menu-btn search-btn-pad" onClick={onSubmitHandlerb}>Search all</button>
                    </div>
                </div>
                

                {/*Drop Down Box for kiosk/venues */}
                
                {/*<h4 className="card-header admin-subheader-2 admin-subheader">Search Reservations By Kiosk</h4>*/}
                {/*<div className="search-box-pad btm-box-border">*/}
                {/*    <select className="kiosk-dropdown" value={formValuec} onChange={onChangeHandlerc}>*/}
                {/*        <option key={'default'} value={""}>Select Kiosk . . .</option>*/}
                {/*        {*/}
                {/*            kiosks.map((val) =>*/}
                {/*                <option key={val} value={val}>{val}</option>*/}
                {/*            )*/}
                {/*        }*/}
                {/*    </select>*/}
                {/*    <button className="btn btn-sm btn-success search-btn-pad" onClick={onSubmitHandlerc}>Sumbit</button>*/}
                {/*</div>*/}

                <Link to={`/admin/reservations/list/` + `,` + today + `,` + ( accountService.configValue['multiDay'] === 'true' ? tomorrow : today) + `,`} className="home-btn admin-menu-btn admin-menu-first"><h3 className="">Today's Reservations</h3></Link>
                <br />
                <Link to={`/admin/reservations/list/` + `,` + tomorrow + `,` + ( accountService.configValue['multiDay'] === 'true' ? day_after_tomorrow : tomorrow) + `,`} className="home-btn home-rsv-btn home-btn-last"><h3>Tomorrow Reservations</h3></Link>
            </div>

            <div>
                <h3 className="card-header admin-top-bdrline">
                    <Link to={`/admin`} className="btn btn-link">Back</Link>
                </h3>
            </div>

        </div>

    );
}

export { Search };